<script setup>
defineProps({
    grids: { type: Object, default: () => null }
});
</script>

<template>
    <div v-if="grids">
        <div class="text-subtitle-1 text-primary mb-3 font-weight-bold">
            <v-icon v-if="grids.icon">{{ grids.icon }}</v-icon>
            {{ $t(grids.title) }}
        </div>

        <v-container class="mx-auto" v-if="grids && grids.data">
            <v-row align="center">
                <v-col
                    cols="4"
                    xl="4"
                    lg="6"
                    md="12"
                    class="py-1 px-1"
                    v-for="(grid, i) in grids.data"
                    :key="i"
                >
                    <v-card color="primary" variant="flat" class="rounded-0">
                        <v-card-item>
                            <div
                                class="text-h6 mb-1 text-end text-no-wrap text-truncate"
                            >
                                {{ grid.value }}
                            </div>
                        </v-card-item>
                        <v-card-actions>
                            <div class="text-caption font-weight-bold">
                                {{ grid.label ? $t(grid.label) : '' }}
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
